module.exports = __webpack_public_path__ + "static/cover.f9fed578.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/master_class/cover.png
// module id = 151
// module chunks = 35783957827783 149428911916780